import { ConstantPool, ThrowStmt } from '@angular/compiler';
import { Component, OnInit } from '@angular/core';
import { BUSINESS_CONST } from 'src/app/shared/constants/business.constants';
import {
  ProductsBiocatchEnum,
  StepBiocatchEnum,
} from 'src/app/shared/enums/biocatchContext.enum';
import { BitacoraService } from 'src/app/shared/services/bitacora/bitacora.service';
import { CaptureService } from 'src/app/shared/services/capture/capture.service';
import { BioCatchService } from 'src/app/shared/services/external/biocatch/biocatch.service';
import { ParametersService } from 'src/app/shared/services/parameters/parameters.service';
import { IdentificationService } from 'src/app/shared/services/identification/identification.service';
import { PostValidateService } from 'src/app/shared/services/post-validate/post-validate.service';

import { RISK_LEVELS } from '../../../shared/constants/rate.constants';
import { OpEnum } from '../../../shared/enums/op.enum';
import { DocumentModel } from '../../../shared/models/document.model';
import { AbreCuentasService } from '../../../shared/services/abre-cuentas/abre-cuentas.service';
import { CopyService } from '../../../shared/services/copies/copy.service';
import { HeaderService } from '../../../shared/services/header/header.service';
import { NavigationService } from '../../../shared/services/navigation/navigation-onboarding.service';
import { RequestService } from '../../../shared/services/request/request-onboarding.service';
import { HelpersService } from '../../../shared/services/helpers/helpers-onboarding.service';
import { ProductLoaderService } from './../../../shared/services/product-loader/product-loader.service';
import { AdjustEvent } from 'src/app/shared/services/external/adjust/adjust.service';
import { callbackAdjustContratarTC } from 'src/app/shared/constants/adjust-callback';
import { TaggingService } from 'src/app/shared/services/tagging/tagging.service';

@Component({
  selector: 'app-offer',
  templateUrl: './offer.component.html',
  styleUrls: ['./offer.component.scss'],
})
export class OfferComponent implements OnInit {
  options: [any];
  screenCopies: any;
  product_type: string;
  resultPco: string;
  documentInfo: DocumentModel;
  aliances: any;
  amount: any;
  mes: any;
  caseNum: any;
  taxRates: any;
  amountPco: any;
  taxInfo: any;
  hasLoanProduct: boolean;
  segment_id: any;
  showRate = false;
  aprovedAmount;
  productsMulti: any[] = [];
  /* Tipo de living place
   * leasing, cartera o hiptecario
   */
  subtype: any;
  /* Sublinea relacionada al subtype
   */
  codesubline: string;
  /* Nombre Sublinea relacionada al subtype
   */
  subline: string;
  /* Porcentaje de opcion de compra
   * Solo aplica para sublinea leasing habitacional
   * purchase: true or false
   * purchasePercent: % entregado por el simulador
   */
  purchase: any;
  purchasePercent: any;
  /* si es credito o solicitud en el label
   * Crédito para hipotecario y solicitud para leasing y cartera
   */
  labelDetail: string;
  /* si es valor solicitado o monto aprobado en el label
   * monto para hipotecario y valor para leasing y cartera
   */
  labelValue: string;
  /* aprobado o aprobada
   * aprobado para hipotecario y leasing aprobada para cartera
   */
  textApproved: string;
  /* Monto inicial solicitado de acuerdo a PCO
   */
  initial_amount: any;
  initAmount: any;
  rateLiving: any;
  rateTerm;
  continueRelated: boolean;
  /*Mock datos del simulador
   */
  simulator: any;
  readonly RISK_LEVELS = RISK_LEVELS;
  constructor(
    public copyService: CopyService,
    private headerService: HeaderService,
    private navigationService: NavigationService,
    private captureService: CaptureService,
    public abreCuentasService: AbreCuentasService,
    private parametersService: ParametersService,
    private requestService: RequestService,
    private biocatchService: BioCatchService,
    private bitacoraService: BitacoraService,
    private productLoaderService: ProductLoaderService,
    public helperService: HelpersService,
    private postValidate: PostValidateService,
    private identificationService: IdentificationService,
    private adjustEvent: AdjustEvent,
    private taggingService: TaggingService,
  ) {
    this.headerService.show(false, true, true);
  }

  ngOnInit() {
    this.sendTagging('init');
    this.rateTerm = this.abreCuentasService.getAbreCuentasModel().creditParms.maxPeriodValue;
    const product = this.abreCuentasService.getproductSelected().product_code as ProductsBiocatchEnum;
    this.caseNum = this.abreCuentasService.getAbreCuentasModel().solicitationId;
    this.mes = this.abreCuentasService.getAbreCuentasModel().creditParms.maxPeriodValue;
    // productsMulti -> get list of multiproduct
    this.productsMulti = this.abreCuentasService.getProductsSelects();
    const isPreloginOnly = (this.biocatchService.isEvidenteCase() && product === ProductsBiocatchEnum.VIV);
    this.biocatchService.changeContext(StepBiocatchEnum.oferta, product, false, isPreloginOnly);
    this.screenCopies = {};
    this.documentInfo = this.abreCuentasService.getDocumentInfo();
    const productSelected = this.abreCuentasService.getproductSelected();
    this.hasLoanProduct = this.loanExists();
    this.product_type = productSelected.product_type;
    const dataProducts = this.productsMulti.filter(dataProduct => dataProduct.product_type === BUSINESS_CONST.PRODUCT_TYPE_FREE);
    if (this.product_type === BUSINESS_CONST.PRODUCT_TYPE_FREE || dataProducts.length > 0) {

      this.amount = '';

      if (this.abreCuentasService.viewOptionMultiProduct) {
        this.productsMulti.forEach(products => {
          this.aprovedAmount = this.abreCuentasService.getAmout(products.product_type) ?
            this.abreCuentasService.getAmout(products.product_type).toString() : '';
        });
      } else {
        this.amount = this.abreCuentasService.getAmountPcoAproved() !== undefined
          ? this.abreCuentasService.getAmountPcoAproved().toString()
          : ' ';
      }

      this.mes = this.abreCuentasService.getAbreCuentasModel().creditParms.maxPeriodValue;
      this.segment_id = this.abreCuentasService.getinfoInferredIncomes().segment_id;
      const rates = this.requestService.getRates();
      this.rateLiving = `${rates[0].value}% ${rates[0].type}  (${rates[1].value}% ${rates[1].type})`;
      this.getRates();
    } else if (this.product_type === BUSINESS_CONST.PRODUCT_TYPE_LIVING) {
      this.bitacoraService.saveDataInBitacora('offer_pco_approved');
      const resultpc = this.abreCuentasService.getPcoModel();
      const rates = this.requestService.getRates();
      this.rateLiving = `${rates[0].value}% ${rates[0].type}  (${rates[1].value}% ${rates[1].type})`;
      this.simulator = this.abreCuentasService.getSimulatorModel();
      this.mes = this.simulator.term;
      this.subtype = this.simulator.product_subtype;
      this.subline = this.simulator.product_name;
      this.codesubline = this.simulator.product_subline;
      this.purchase =
        this.subtype === 'LEA' &&
          (this.codesubline === '01' ||
            this.codesubline === '07' ||
            this.codesubline === '03')
          ? true
          : false;
      this.purchasePercent = this.simulator.purchase;
      this.getRates();
    }

    if (this.hasLoanProduct) {
      const rates = this.abreCuentasService.getRatesLoan();
      this.rateLiving = `${rates}`;
    }

    if (!this.abreCuentasService.viewOptionMultiProduct) {
      const amount =
        this.abreCuentasService.getAmountPcoAproved() === undefined ||
          this.abreCuentasService.getAmountPcoAproved() === null
          ? 0
          : this.abreCuentasService.getAmountPcoAproved();
      this.amount = amount.toString();
      this.amountPco = this.amount
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
        .split(/\ /)
        .join('')
        .trim();
    }
    /*else{
      console.log('--', this.abreCuentasService.getAbreCuentasModel());
      const amount =
        this.abreCuentasService.getAmountPcoAprovedMulti('') != undefined ||
          this.abreCuentasService.getAmountPcoAproved() === null
          ? 0
          : this.abreCuentasService.getAmountPcoAproved();
      this.amount = amount.toString();
      this.amountPco = this.amount
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
        .split(/\ /)
        .join('')
        .trim();
    }*/

    this.resultPco = 'PCO01';
    this.setCopies(this.resultPco);
  }

  getRates() {
    this.taxRates = this.requestService.getRates();
    this.showRate = true;
  }

  /**
   * Summary Go to next Step
   */
  setCopies(resultPco) {
    switch (resultPco) {
      case 'PCO01':
        switch (this.product_type) {
          case BUSINESS_CONST.PRODUCT_TYPE_TC:
            this.screenCopies = this.copyService.copies.offer_multi;
            this.options = this.parametersService.getSetting(
              OpEnum.ALLIANCES_TC,
            );
            break;
          case BUSINESS_CONST.PRODUCT_TYPE_REVOLVING:
            this.screenCopies = this.copyService.copies.resolvinf_credit;
            this.options = this.parametersService.getSetting(
              OpEnum.REVOLVING_CREDIT_CHARACTERISTICS,
            );
            break;
          case BUSINESS_CONST.PRODUCT_TYPE_FREE:
            this.screenCopies = this.copyService.copies.type_free;
            this.options = this.parametersService.getSetting(
              OpEnum.FREE_CREDIT_CHARACTERISTICS,
            );
            break;
          case BUSINESS_CONST.PRODUCT_TYPE_LIVING:
            this.screenCopies = this.copyService.copies.offer_type_living;
            this.textApproved =
              (this.subtype === 'LEA' && this.codesubline === '03') ||
                (this.subtype === 'HIP' && this.codesubline === '55')
                ? this.screenCopies.title_5
                : this.screenCopies.title_4;
            if (
              this.subtype === 'LEA' ||
              (this.subtype === 'HIP' && this.codesubline === '55')
            ) {
              this.labelDetail = this.screenCopies.text_zona_gris;
            } else {
              this.labelDetail = this.screenCopies.text_zona_gris2;
            }
            this.labelValue = this.screenCopies.valor;
            this.options = this.parametersService.getSetting(
              OpEnum.LIVING_CHARACTERISTICS,
            );
            break;
          case BUSINESS_CONST.MULTI:
            this.screenCopies = this.copyService.copies.offer_multi;
            break;
          default:
            break;
        }
        break;
      case 'PCO02':
        switch (this.product_type) {
          case BUSINESS_CONST.PRODUCT_TYPE_REVOLVING:
            this.screenCopies = this.copyService.copies.offer_resolvinf_credit;
            this.options = this.parametersService.getSetting(
              OpEnum.REVOLVING_CREDIT_CHARACTERISTICS_MULTI,
            );
            break;
          case BUSINESS_CONST.PRODUCT_TYPE_FREE:
            this.screenCopies = this.copyService.copies.offer_type_free;
            this.options = this.parametersService.getSetting(
              OpEnum.FREE_CREDIT_CHARACTERISTICS,
            );
            break;
          default:
            break;
        }
        break;
      default:
        break;
    }
  }

  loanExists() {
    let exists = false;
    this.productsMulti.forEach(dataProduct => {
      if (dataProduct.product_type === BUSINESS_CONST.PRODUCT_TYPE_LOAN) {
        exists = true;
      }
    });
    return exists;
  }

  goToSupportDocuments() {
    this.navigationService.navigateTo('support-documents');
  }

  previous() {
    this.sendTagging('prev', 'center' , '1');
    this.bitacoraService.saveDataInBitacora('mejor_otro_dia_pco');
    this.navigationService.navigateToGeneralInformation('512');
  }

  editOfert(product) {
    this.abreCuentasService.setEditProduct(product);
    this.navigationService.nextStep('202');
  }

  async checkBioCatch() {
    this.sendTagging('next', 'center' , '2');
    if (this.product_type !== BUSINESS_CONST.PRODUCT_TYPE_LIVING) {
      this.next();
      return;
    }
    await this.biocatchService.update();
    this.biocatchService.checkScore(false).then(response => {
      if (response.data.response) {
        this.next();
        return;
      }
      this.navigationService.navigateToGeneralInformation('122');
      this.navigationService.pageLoadTag('Error carga vinculacion', ['', 'pv132', 'pv93']);
    }, () => {
      this.navigationService.navigateToGeneralInformation('500');
    }).catch(() => this.navigationService.navigateToGeneralInformation('500'));
  }

  async next() {
    if (this.product_type === BUSINESS_CONST.PRODUCT_TYPE_LIVING) {
      this.productLoaderService.show(this.copyService.copies.show_offer_pco);
      if (
        this.abreCuentasService.getProspectResponse().list_query_status
          .status_code === '2' ||
        (typeof this.abreCuentasService.getSecondHeadline() !== 'undefined' &&
          this.abreCuentasService.getSecondHeadline().has_second_headline &&
          this.abreCuentasService.getProspectResponseSecondHeadLine()
            .list_query_status.status_code === '2')
      ) {
        await this.abreCuentasService.sleep(2000);
        this.productLoaderService.hide();
        this.navigationService.navigateToGeneralInformation('130');
        return;
      }

      // Relacionados
      await this.checkRelated();
      if (!this.continueRelated) {
        this.productLoaderService.hide();
        return;
      }

      this.productLoaderService.show(this.copyService.copies.show_offer_pco,
        this.parametersService.getSetting(OpEnum.TIMER_WINDOWS_ORANGE)['ALTA']);
      this.bitacoraService.saveDataInBitacora('Ini_loading_Product');

      try {
        await this.postValidate.createClient();
        await this.postValidate.createProducts();
        await this.postValidate.performSolicitation();
        await this.abreCuentasService.sleep(this.parametersService.getSetting(OpEnum.TIMER_WINDOWS_ORANGE)['ALTA']);
        await this.captureService
          .getChannelComunicator(true)
          .then((res2: any) => {
            if (res2 === '208') {
              this.bitacoraService.saveDataInBitacora('Possible_fraud_Yes');
            } else if (res2 === '20-04') {
              res2 = '208';
              this.bitacoraService.saveDataInBitacora('Possible_fraud_incident');
            }
            res2 === '107' ||
              res2 === '121' ||
              res2 === '130' ||
              res2 === '129' ||
              res2 === '124' ||
              res2 === '127'
              ? this.navigationService.navigateToGeneralInformation(res2)
              : this.navigationService.nextStep(res2);
            if (this.product_type === BUSINESS_CONST.PRODUCT_TYPE_TC && res2 === '121') {
              const event = {
                eventToken: 'huswfn',
                callbackParams: callbackAdjustContratarTC,
              };
              this.adjustEvent.adjustTrackEvent(event);
            }
            this.bitacoraService.saveDataInBitacora('Out_loading_Product');
            this.productLoaderService.hide();
          })
          .catch(() =>
            this.navigationService.navigateToGeneralInformation('107'),
          );
      } catch (error) {
        console.log(error);
        this.navigationService.navigateToGeneralInformation('107');
      }
      this.bitacoraService.saveDataInBitacora('product_accepted_approved');
      return;
    }
    this.navigationService.nextStep('200');
  }

  listBenefits(row: any) {
    return this.parametersService.getSetting(row.options);
  }

  getAmountProducts(type: any) {
    return this.abreCuentasService.getAmout(type).toString().
      replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
      .split(/\ /)
      .join('')
      .trim();
  }

  async checkRelated() {
    this.continueRelated = true;
    let document = this.abreCuentasService.getDocumentInfo().document_number;
    const resInfo = await this.identificationService.validateIfIsRelated(document);
    console.log('resInfo');
    console.log(resInfo);
    if (!resInfo.related) { return; }
    // BITÁCORA CON employee_members
    const bitacoraEvent = `employee_members`;
    this.bitacoraService.saveDataInBitacora(bitacoraEvent);

    // Verificar estado PCO
    let pcoStatus = this.abreCuentasService.getPcoModel().solicitation_status.status_code;

    console.log('pcoStatus');
    console.log(pcoStatus);
    // PCO Aprobado continúa a "Tu solicitud fue recibida y la estamos validando"
    if (pcoStatus !== 'PCO01') { return; }
    this.navigationService.nextStep('203');
    this.continueRelated = false;
  }

  sendTagging(value: any, position?: string, event?: string) {
    const page = '6';
    const extras = {
      object: 'transactionProductCategory',
      value: 'Aprobado',
      pageValue: 'Offer',
    };
    this.taggingService.sendTaggValues(value, page, position, event, extras);
  }

}
